import { render, staticRenderFns } from "./EditarCobro.vue?vue&type=template&id=72a5a281&scoped=true"
import script from "./EditarCobro.vue?vue&type=script&lang=js"
export * from "./EditarCobro.vue?vue&type=script&lang=js"
import style0 from "./EditarCobro.vue?vue&type=style&index=0&id=72a5a281&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a5a281",
  null
  
)

export default component.exports